import img_game_logo from 'assets/images/game_logo.min.png';
import mPlayerWrapper, {
  PlayerListener,
  Animation,
} from 'spine-player/spine-player-wrapper';

import board from 'assets/images/board.min.png';
import bg from 'assets/images/bg.min.png';
import t from 'assets/images/t.min.png';
import mine from 'assets/images/mine.min.png';
import prize from 'assets/images/prize.min.png';
import UIMain from 'assets/images/UI_Main.min.png';
import UITop from 'assets/images/UI_Top.min.png';
import img_explosion from 'assets/images/explosion.min.png';
import sound_button_enable from 'assets/sounds/button_enable.mp3';
import sound_button_hover from 'assets/sounds/button_hover.mp3';
import sound_dynamite_explosion from 'assets/sounds/dynamite_explosion.mp3';
import sound_game_starter from 'assets/sounds/game_starter.mp3';
import sound_gold_reveal from 'assets/sounds/gold_reveal.mp3';
import sound_stone_click from 'assets/sounds/stone_click.mp3';
import sound_stone_hover from 'assets/sounds/stone_hover.mp3';
import sound_win from 'assets/sounds/win.mp3';
import main_theme from 'assets/sounds/main_theme.mp3';
import sad from 'assets/sounds/sad.mp3';
import happy from 'assets/sounds/happy.mp3';
import encourage from 'assets/sounds/encourage.mp3';
import sleepy from 'assets/sounds/sleepy.mp3';
import wake_up from 'assets/sounds/wake_up.mp3';
import yawn from 'assets/sounds/yawn.mp3';

import { TFiles } from './types';

export const files: TFiles = {
  image: [img_game_logo, bg, board, t, mine, prize, UIMain, UITop],
  fetch: [
    sound_button_enable,
    sound_button_hover,
    sound_dynamite_explosion,
    sound_game_starter,
    sound_gold_reveal,
    sound_stone_click,
    sound_stone_hover,
    sound_win,
    main_theme,
    sad,
    happy,
    encourage,
    sleepy,
    wake_up,
    yawn,
  ],
  imageToBlob: [img_explosion],
  callback: [
    cb => {
      setTimeout(() => {
        cb();
      }, 1000);
    },
    cb => {
      const listener: PlayerListener = {
        onReady() {
          mPlayerWrapper.unsubscribeListener(listener);
          cb();
        },

        onAnimationStart(animation: Animation) {},
      };

      mPlayerWrapper.subscribeListener(listener);
    },
  ],
};
